import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { dtpJobRetrieveRequest } from 'actions/jobs/employees';
import { isDtpJobDetailLoading } from 'selectors/loading';
import EmployeeJobDetailHOC from './EmployeeJobDetailHOC';
import JobDetail from './presenter';


const mapStateToProps = (state, props) => {
  const { id } = props.params;
  return {
    id,
    roleKey: 'dtp',
    isLoading: isDtpJobDetailLoading(state, id),
  }
}

const mapDispatchToProps = (disptach) => {
  return bindActionCreators({
    retrieveRequest: dtpJobRetrieveRequest,
  }, disptach)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmployeeJobDetailHOC(JobDetail));